'use client';

import React, { useRef } from 'react';

export default function ListMap({ maps, currentMapId, onMapSelect }: { maps: any[], currentMapId?: string | number, onMapSelect?: (map: any) => void }) {
    // Track touch start position to differentiate tap from scroll
    const touchStartRef = useRef<{ x: number; y: number } | null>(null);

    const handleMapClick = (event: React.MouseEvent<HTMLDivElement>, map: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (onMapSelect) {
            onMapSelect(map);
        }
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        const touch = e.touches[0];
        touchStartRef.current = { x: touch.clientX, y: touch.clientY };
    };

    const handleTouchEnd = (e: React.TouchEvent, map: any) => {
        if (!touchStartRef.current) return;

        const touch = e.changedTouches[0];
        const dx = Math.abs(touch.clientX - touchStartRef.current.x);
        const dy = Math.abs(touch.clientY - touchStartRef.current.y);

        // Only trigger if it was a tap (not a scroll/swipe)
        if (dx < 10 && dy < 10) {
            e.preventDefault();
            e.stopPropagation();
            if (onMapSelect) {
                onMapSelect(map);
            }
        }

        touchStartRef.current = null;
    };

    return (
        <div className="flex items-end gap-3 overflow-x-auto">
            {maps && maps.length > 0 ? (
                maps.map((map, index) => {
                    const isActive = Number(currentMapId) === Number(map.id);
                    const isLocked = Number(map?.require_login) === 1;
                    return (
                        // <div
                        //     key={map.id || index}
                        //     onClick={() => onMapSelect && onMapSelect(map)}
                        //     className={`
                        //         relative cursor-pointer transition-all duration-300 ease-out flex-shrink-0
                        //         rounded-md overflow-hidden bg-gray-200
                        //         ${isActive
                        //             ? 'w-[60px] h-[60px] lg:w-[70px] lg:h-[70px] 2xl:w-[80px] 2xl:h-[80px] border-[3px] border-[var(--carousel-outline-highlight)] shadow-xl z-10'
                        //             : 'w-[45px] h-[45px] lg:w-[55px] lg:h-[55px] 2xl:w-[65px] 2xl:h-[65px] border-[2px] border-[var(--carousel-outline-default)]'
                        //         }
                        //     `}
                        // >
                        //     <img
                        //         src={map.url_map}
                        //         alt={map.title || `Map ${index}`}
                        //         className="w-full h-full object-cover"
                        //     />
                        // </div>

                        <div
                            key={map.id || index}
                            onClick={(event) => handleMapClick(event, map)}
                            onTouchStart={handleTouchStart}
                            onTouchEnd={(e) => handleTouchEnd(e, map)}
                            className={`
                                relative cursor-pointer transition-all duration-300 ease-out flex-shrink-0
                                rounded-md overflow-hidden bg-gray-200
                                ${isActive
                                    ? 'w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] 2xl:w-[120px] 2xl:h-[120px] border-[3px] border-[var(--carousel-outline-highlight)] shadow-xl z-10'
                                    : 'w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] 2xl:w-[120px] 2xl:h-[120px] border-[2px] border-[var(--carousel-outline-default)]'
                                }
                            `}
                            style={{ touchAction: 'manipulation' }}
                        >
                            <img
                                src={map.url_map}
                                alt={map.title || `Map ${index}`}
                                draggable={false}
                                className={`w-full h-full object-cover ${isLocked ? 'opacity-50' : ''}`}
                            />

                            {isLocked && (
                                <span className="absolute top-1 left-1 z-20 bg-black/70 text-white text-[10px] px-1.5 py-0.5 rounded">
                                    LOCK
                                </span>
                            )}

                            <span className={`px-1 flex items-center justify-center w-full h-full absolute top-0 left-0 text-center text-white text-uppercase text-center text-xs ${isActive ? 'bg-[var(--thumbnail-overlay-active)]' : 'bg-[var(--thumbnail-overlay-default)]'}`}>
                                {map.title}
                            </span>
                        </div>
                    );
                })
            ) : null}
        </div>
    );
}
